export const CLASS_TYPES = {
  lecture: 'Lecture',
  contest: 'Contest',
  classWithoutLiveLecture: 'Class without Live Lecture',
};

export const INSTRUCTOR_REQUIRED_CLASS_TYPES = [CLASS_TYPES.lecture];
